import { GridSortItem } from '@mui/x-data-grid/models/gridSortModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IObject } from '../interfaces/IObject';

interface StampState {
  filters: IObject;
  sorting: GridSortItem[];
  pageNumber: number;
  refreshKey: boolean;
}

const initialState: StampState = {
  filters: { value: null, serial_number: null, status: null, draft_name: null },
  sorting: [],
  pageNumber: 0,
  refreshKey: false,
};

const stampSlice = createSlice({
  name: 'stamp',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<IObject>) => {
      state.filters = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sorting = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setRefreshKey: (state, action: PayloadAction<boolean>) => {
      state.refreshKey = action.payload;
    },
  },
});

export const { setFilters, setSorting, setPageNumber, setRefreshKey } =
  stampSlice.actions;

export default stampSlice.reducer;
